import {
  LayoutDashboard,
  Users,
  BookOpen,
  Tag,
  ClipboardList,
  Activity,
  BarChart3,
  TrendingUp,
  Brain,
  ClipboardCheck,
  Target,
  CreditCard,
  ShoppingCart,
  Award,
  DollarSign,
  Percent,
  Sparkles,
  FileText,
  Mail,
  Trophy,
  Coins,
  Shield,
  ShieldAlert,
  ScanSearch,
  Lock,
  Zap,
  Rocket,
  Flag,
  UserCog,
  Headphones,
  MessageSquare,
  UserPlus,
  Megaphone,
  KeyRound,
  Package,
  Command,
  Crown,
  Briefcase,
} from "lucide-react";
import type { SidebarSectionConfig } from "./userSidebarConfig";

/**
 * Admin sidebar — organized into 7 areas as defined by the product spec:
 * Operações (6) · Crescimento e Análise (8) · Monetização (6) · Conteúdo (3) ·
 * Gamificação (5) · Suporte (4) · Segurança (6)
 */
export const adminSidebarConfig: SidebarSectionConfig[] = [
  {
    labelKey: "sidebar.sections.operation",
    items: [
      { to: "/admin", icon: LayoutDashboard, labelKey: "sidebar.admin.overview", end: true },
      { to: "/admin/control-center", icon: Command, labelKey: "sidebar.admin.controlCenter" },
      { to: "/admin/users", icon: Users, labelKey: "sidebar.admin.users" },
      { to: "/admin/instructors", icon: UserCog, labelKey: "sidebar.admin.instructors" },
      { to: "/admin/courses", icon: BookOpen, labelKey: "sidebar.admin.courses" },
      { to: "/admin/bootcamps", icon: Rocket, labelKey: "sidebar.admin.bootcamps" },
      { to: "/admin/bootcamps/operations", icon: Activity, labelKey: "sidebar.admin.bootcampOps" },
      { to: "/admin/categories", icon: Tag, labelKey: "sidebar.admin.categories" },
      { to: "/admin/enrollments", icon: ClipboardList, labelKey: "sidebar.admin.enrollments" },
      { to: "/admin/activity-tracking", icon: Activity, labelKey: "sidebar.admin.activity" },
      { to: "/admin/feature-flags", icon: Flag, labelKey: "sidebar.admin.featureFlags" },
    ],
  },
  {
    labelKey: "sidebar.sections.prepPremium",
    items: [
      { to: "/admin/prep", icon: Crown, labelKey: "sidebar.admin.prepHub", end: true },
      { to: "/admin/prep/settings", icon: Flag, labelKey: "sidebar.admin.prepSettings" },
      { to: "/admin/prep/products", icon: Package, labelKey: "sidebar.admin.prepProducts" },
      { to: "/admin/prep/questions", icon: FileText, labelKey: "sidebar.admin.prepQuestions" },
      { to: "/admin/prep/rubrics", icon: ClipboardCheck, labelKey: "sidebar.admin.prepRubrics" },
      { to: "/admin/prep/contests", icon: BookOpen, labelKey: "sidebar.admin.prepContests" },
      { to: "/admin/prep/interview-tracks", icon: Briefcase, labelKey: "sidebar.admin.prepInterviewTracks" },
    ],
  },
  {
    labelKey: "sidebar.sections.growth",
    items: [
      { to: "/admin/analytics", icon: BarChart3, labelKey: "sidebar.admin.analytics" },
      { to: "/admin/advanced-analytics", icon: TrendingUp, labelKey: "sidebar.admin.advancedAnalytics" },
      { to: "/admin/business-growth", icon: Sparkles, labelKey: "sidebar.admin.businessGrowth" },
      { to: "/admin/user-intelligence", icon: Brain, labelKey: "sidebar.admin.userIntelligence" },
      { to: "/admin/quiz-analytics", icon: ClipboardCheck, labelKey: "sidebar.admin.quizAnalytics" },
      { to: "/admin/ab-testing", icon: Target, labelKey: "sidebar.admin.abTesting" },
      { to: "/admin/ai-quiz-tools", icon: Brain, labelKey: "sidebar.admin.aiQuizTools" },
      { to: "/admin/ai-governance", icon: Sparkles, labelKey: "sidebar.admin.aiGovernance" },
      { to: "/admin/marketing-campaigns", icon: Megaphone, labelKey: "sidebar.admin.marketing" },
    ],
  },
  {
    labelKey: "sidebar.sections.monetization",
    items: [
      { to: "/admin/subscription-management", icon: CreditCard, labelKey: "sidebar.admin.subscriptions" },
      { to: "/admin/platform-plans", icon: Award, labelKey: "sidebar.admin.plans" },
      { to: "/admin/payment-operations", icon: DollarSign, labelKey: "sidebar.admin.paymentOps" },
      { to: "/admin/payment-health", icon: Activity, labelKey: "sidebar.admin.paymentHealth" },
      { to: "/admin/orders", icon: ClipboardList, labelKey: "sidebar.admin.orders" },
      { to: "/admin/abandoned-carts", icon: ShoppingCart, labelKey: "sidebar.admin.abandonedCarts" },
      { to: "/admin/bundles", icon: Package, labelKey: "sidebar.admin.bundles" },
      { to: "/admin/recommendations", icon: Sparkles, labelKey: "sidebar.admin.recommendations" },
      { to: "/admin/promotions", icon: Sparkles, labelKey: "sidebar.admin.promotions" },
      { to: "/admin/discounts", icon: Percent, labelKey: "sidebar.admin.discounts" },
    ],
  },
  {
    labelKey: "sidebar.sections.content",
    items: [
      { to: "/admin/blog", icon: FileText, labelKey: "sidebar.admin.blog" },
      { to: "/admin/communications", icon: Mail, labelKey: "sidebar.admin.communications" },
      { to: "/admin/emails", icon: Mail, labelKey: "sidebar.admin.emailMonitor" },
      { to: "/admin/challenges", icon: Flag, labelKey: "sidebar.admin.challenges" },
    ],
  },
  {
    labelKey: "sidebar.sections.gamification",
    items: [
      { to: "/admin/gamification", icon: Trophy, labelKey: "sidebar.admin.gamification" },
      { to: "/admin/badges", icon: Award, labelKey: "sidebar.admin.badges" },
      { to: "/admin/silva-coins", icon: Coins, labelKey: "sidebar.admin.coins" },
      { to: "/admin/certificates", icon: Award, labelKey: "sidebar.admin.certificates" },
      { to: "/admin/achievements", icon: Trophy, labelKey: "sidebar.admin.achievements" },
    ],
  },
  {
    labelKey: "sidebar.sections.adminSupport",
    items: [
      { to: "/admin/customer-support", icon: Headphones, labelKey: "sidebar.admin.customerSupport" },
      { to: "/admin/feedback", icon: MessageSquare, labelKey: "sidebar.admin.feedback" },
      { to: "/admin/invitations", icon: UserPlus, labelKey: "sidebar.admin.invitations" },
      { to: "/admin/access-management", icon: UserCog, labelKey: "sidebar.admin.access" },
      { to: "/admin/role-management", icon: KeyRound, labelKey: "sidebar.admin.roleManagement" },
    ],
  },
  {
    labelKey: "sidebar.sections.security",
    items: [
      { to: "/admin/security", icon: Shield, labelKey: "sidebar.admin.security" },
      { to: "/admin/security-audit", icon: ShieldAlert, labelKey: "sidebar.admin.audit" },
      { to: "/admin/security-scanner", icon: ScanSearch, labelKey: "sidebar.admin.scanner" },
      { to: "/admin/security-compliance", icon: Lock, labelKey: "sidebar.admin.compliance" },
      { to: "/admin/security-vulnerability-testing", icon: Zap, labelKey: "sidebar.admin.vulnerability" },
      { to: "/admin/integration-testing", icon: ClipboardCheck, labelKey: "sidebar.admin.integration" },
      { to: "/admin/privacy", icon: Shield, labelKey: "sidebar.admin.privacy" },
      { to: "/admin/account-lifecycle", icon: UserCog, labelKey: "sidebar.admin.accountLifecycle" },
    ],
  },
];
